import { render, staticRenderFns } from "./transcript.vue?vue&type=template&id=c3b4bbfc"
import script from "./transcript.vue?vue&type=script&lang=js"
export * from "./transcript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports